import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { HelpCircle } from "lucide-react";

interface PreparationStatusFieldsProps {
  profile: any;
  setProfile: (profile: any) => void;
  readOnly: boolean;
  loading: boolean;
}

export function PreparationStatusFields({
  profile,
  setProfile,
  readOnly,
  loading
}: PreparationStatusFieldsProps) {
  return (
    <div className="space-y-1">
      <div className="flex items-center gap-1">
        <label className="text-sm font-medium">
          Teilnahme an Vorbereitungskurs für die Kenntnisprüfung
        </label>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger>
              <HelpCircle className="h-4 w-4 text-gray-400" />
            </TooltipTrigger>
            <TooltipContent>
              <p>
                Nimmt die Person an einem Vorbereitungskurs für die
                Kenntnisprüfung teil?
              </p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
      <Select
        disabled={readOnly}
        value={profile?.preparation_course_enrolled ? "yes" : "no"}
        onValueChange={(value) =>
          setProfile({
            ...profile!,
            preparation_course_enrolled: value === "yes"
          })
        }
      >
        <SelectTrigger loading={loading}>
          <SelectValue placeholder="Bitte auswählen" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="yes">Ja</SelectItem>
          <SelectItem value="no">Nein</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
